<template>
  <div>
    <Modal
      v-model="visible"
      :title="formData.id ? '编辑' : '新增'"
      :closable="true"
      :mask-closable="false"
      width="1185"
      :footer-hide="true"
      class="my-modal top import-tool-modal2"
    >
      <Form ref="formInline" class="page-form" :model="formData" :rules="formDataValidate" :label-width="100">
        <FormItem label="批单号" prop="billNo" :rules="$units.formRule.required('请输入')">
          <Input type="text" placeholder="请输入" v-model="formData.billNo" clearable />
        </FormItem>
        <FormItem label="变更类型">
          <Select v-model="formData.type" :transfer="true" clearable @on-change="changeType">
            <Option value="1">增保</Option>
            <Option value="3">减保</Option>
            <Option value="2">替保</Option>
          </Select>
        </FormItem>
        <FormItem label="变更内容" v-if="formData.type">
          <div class="change-content">
            <div v-if="formData.type == '1' || formData.type == '2'">
              <InputNumber style="width: 80px" :min="1" :step="1" v-model="formData.addCounts" :precision="0"></InputNumber>
              <span class="lable">人加保</span>
            </div>
            <div v-if="formData.type == '3' || formData.type == '2'">
              <InputNumber style="width: 80px" :min="1" :step="1" v-model="formData.delCounts" :precision="0"></InputNumber>
              <span class="lable">人减保</span>
            </div>
          </div>
        </FormItem>
        <FormItem label="变更保费" prop="fee" :rules="$units.formRule.positiveNumber()">
          <Input type="text" placeholder="请输入" :disabled="formData.type == 2 ? true : false" v-model="formData.fee" clearable />
        </FormItem>
        <FormItem label="批单生效日期" prop="startTime" :rules="$units.formRule.required('请选择')">
          <DatePicker
            :value="formData.startTime"
            @on-change="formData.startTime = $event"
            type="date"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="承保日期" prop="issueTime" :rules="$units.formRule.required('请选择承保日期')">
          <DatePicker
            :value="formData.issueTime"
            @on-change="issueTimeChange"
            type="date"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="投保日期" prop="insureTime" :rules="$units.formRule.required('请选择投保日期')">
          <DatePicker
            :value="formData.insureTime"
            @on-change="formData.insureTime = $event"
            type="date"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="支付日期" prop="payTime" :rules="$units.formRule.required('请选择支付日期')">
          <DatePicker
            :value="formData.payTime"
            @on-change="formData.payTime = $event"
            type="date"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
      </Form>

      <div class="correction-list">
        <span>批改清单</span>
        <div class="label-item">
          <span @click="$refs.batchImport.open(policyNo)">导入批改清单</span>
        </div>
      </div>

      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>

    <!-- 批量导入 -->
    <batchImport ref="batchImport" :type="2" @success-data="getUploadData"></batchImport>
  </div>
</template>

<script>
import batchImport from '../components/batchImport';
import filter from '@/api/filter';

export default {
  components: {
    batchImport
  },
  props: ['endTime'],
  data() {
    return {
      filter,
      policyNo: '',
      visible: false,
      formDataValidate: {},
      jobGradeList: [],
      formData: {},
      insureList: []
    };
  },
  methods: {
    open(data, policyNo) {
      if (data.id) {
        const formData = JSON.parse(JSON.stringify(data));
        this.formData = formData;
        this.changeType(formData.fee);
      } else {
        this.insureList = [];
        this.$set(this.formData, 'billNo', '');
        this.$set(this.formData, 'type', '');
        this.$set(this.formData, 'fee', '');
        this.$set(this.formData, 'startTime', '');
        this.$set(this.formData, 'issueTime', '');
        this.$set(this.formData, 'insureTime', '');
        this.$set(this.formData, 'payTime', '');
        this.$set(this.formData, 'addCounts', 1);
        this.$set(this.formData, 'delCounts', 1);
        delete this.formData.id;
      }
      this.policyNo = policyNo;
      this.visible = true;
      this.$refs.formInline.resetFields();
    },
    // 选择承保时间
    issueTimeChange(date) {
      this.$set(this.formData, 'issueTime', date);
      if (!this.formData.payTime) {
        this.$set(this.formData, 'payTime', date);
      }
    },
    changeType(value) {
      if (value == 2) {
        this.formData.fee = '0';
      }
    },
    getUploadData(list) {
      this.insureList = list;
    },
    save() {
      this.$refs.formInline.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (filter.filterTime(formData.startTime, 'YYYY-MM-DD') > filter.filterTime(this.endTime, 'YYYY-MM-DD')) {
          this.$notice.error('生效日期不能大于保单终保日期');
          return;
        }
        formData.startTime = formData.startTime ? filter.filterTime(formData.startTime, 'YYYY-MM-DD') : '';
        if (formData.type == 1) {
          delete formData.delCounts;
        } else if (formData.type == 3) {
          delete formData.addCounts;
        } else if (formData.type == 2) {
          if (this.formData.delCounts != formData.addCounts) {
            this.$notice.error('替保时加保人数和减保人数需一致');
            return;
          }
        } else {
          delete formData.delCounts;
          delete formData.addCounts;
        }
        if((formData.type == 1 || formData.type == 2) && !formData.addCounts) {
          this.$notice.error('请填写增保变更内容');
          return
        }
        if((formData.type == 3 || formData.type == 2) && !formData.delCounts) {
          this.$notice.error('请填写减保变更内容');
          return
        }
        const data = {
          endorsementBos: {
            ...formData,
            insureList: this.insureList.successList
          },
          policyNo: this.policyNo
        };
        this.$http({
          url: '/buz/grouppolicy/enter/endorsement/saveOrUpdate',
          type: 'POST',
          data
        }).then(res => {
          this.visible = false;
          this.$notice.success(formData.id ? '修改成功' : '新增成功');
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.change-content {
  display: flex;
  justify-content: space-between;
  .lable {
    margin-left: 10px;
  }
}
.correction-list {
  padding: 0 12px;
  display: flex;
  .label-item {
    margin-left: 10px;
    span {
      margin-left: 10px;
      cursor: pointer;
      color: #236dff;
    }
  }
}
</style>
